/** Expected input rejection before a chat turn is submitted. */
export class ChatSendValidationError extends Error {
  name = 'ChatSendValidationError'
}
